<template>
  <div>
    <el-select v-model="un_no" filterable :size="size" :placeholder="placeTitle" remote :remote-method="remoteMethod"
      :clearable="clearable" :disabled="disabled" :loading="loading" :style="{ width: width }"
      :default-first-option='true'>
      <el-option v-for="item in options" :key="item.id" :label="`${item.un_no}/${item.classify}/${item.packing_group}`" :value="item.id">
        <div>{{ `${item.un_no}/${item.classify}/${item.packing_group}`}}</div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "unnoById",
  props: {
    width: {
      type: String,
      default: "",
    },
    placeTitle: {
      type: String,
      default: "",
    },
    value: {
      type: String | Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dangerous_id:{
      type: String | Number,
      default: null,
    }
  },
  data() {
    return {
      options: [],
      un_no: null,
      loading: false,
    };
  },
  mounted() {
    if(this.dangerous_id){
      this.handleInitValue();
    }
  },
  watch: {
    un_no(nv) {
      let obj = this.options.find(item => {
        return item.id == nv
      });
      this.$emit("unnoSelectFunc", obj);
    },
    dangerous_id(nv){
      this.handleInitValue();
    }
  },
  methods: {
    async handleInitValue() {
      if (this.value != "") {
        let parmas = {};
        parmas.un_no = this.value;
        this.$store.dispatch("API_bookingSpace/getUnnoList", parmas).then((res) => {
          this.loading = false;
          if (res.success) {
            this.options = res.data;
            if(this.dangerous_id){
              this.un_no = this.dangerous_id;
            }
          }
        });
      } else {
        // this.un_no=this.value
      }
    },
    async remoteMethod(queryString) {
      this.loading = true;
      let parmas = {};
      parmas.un_no = queryString;
      parmas.limit = 20;
      parmas.start = 0;
      this.$store.dispatch("API_bookingSpace/getUnnoList", parmas).then((res) => {
        this.loading = false;
        if (res.success) {
          this.options = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
